import Vue from '@app/js/modules/vueApp'

window.erpVue = {}

if (document.getElementById('mainmenu')) {
  window.erpVue.mainMenu = new Vue({
    name: 'AppMainMenu'
  }).$mount('#mainmenu')
}

if (document.getElementById('main-vue-app')) {
  window.erpVue.mainApp = new Vue({
    name: 'AppMain'
  }).$mount('#main-vue-app')
}
